<!--
   Created by qing on 2020/10/6
   Des:
-->
<template>
	<div>
		<van-cell class="ry-form__item-button">

			<div
				v-if="current.buttonShowStyle === 'CLASSICS'"
				class="btn"
				:class="{'disabled': btnDisabled}"
				:style="{backgroundColor: current.buttonColor}"
				@click="onClickBtn"
			>
				<i
					v-if="loading"
					class="el-icon-loading"
				></i>
				{{current.buttonName}}
			</div>

			<div
				v-else-if="current.buttonShowStyle === 'CARD'"
				:style="{backgroundColor: actionHexToRgba(current.buttonColor, 0.2)}"
				class="card-container"
			>
				<div class="left-container">
					<div class="btn-title">
						{{current.customConfigInfo.title}}
					</div>
					<div class="btn-des">
						{{current.customConfigInfo.des}}
					</div>
				</div>
				<div class="right-container">
					<div
						class="btn"
						:class="{'disabled': btnDisabled}"
						:style="{backgroundColor: current.buttonColor}"
						@click="onClickBtn"
					>
						{{current.buttonName}}
					</div>
				</div>
			</div>
			<div
				v-else-if="current.buttonShowStyle === 'DIAL'"
				class="dial-container"
				@click="onClickBtn"
			>
				<div
					class="icon menu-icon"
					:style="{backgroundColor: current.customConfigInfo.iconBgColor}"
				>
					<i
						v-if="current.customConfigInfo.iconType === 'system'"
						:class="current.customConfigInfo.icon"
						:style="{color: !current.customConfigInfo.iconBgColor || ['#FFFFFF', '#ffffff'].includes(current.customConfigInfo.iconBgColor) ? '#333333' : '#ffffff'}"
					></i>
					<img
						v-else
						class="custom-app-icon-img"
						:src="current.customConfigInfo.iconUrl"
						alt=""
					>
				</div>
				<div class="text">
					{{current.buttonName}}
				</div>
			</div>

		</van-cell>

		<RySelectPopup
			ref="rySelectPopup"
			:title="current.title"
			@selectComplete="selectComplete"
		>
		</RySelectPopup>

		<create-form-apply
			:key="current.dataId"
			ref="createFormApply"
			:appId="current.applyAppId"
			:formId="current.applyFormId"
			:needButton="false"
			:reqDefaultSubmitData="false"
			@formSetFinalComplete="createFormComplete"
		>
		</create-form-apply>
	</div>

</template>

<script>
	import {
		current
	} from './mixin'
	import {
		BUTTON_TYPE_APPLY_FORM,
		BUTTON_TYPE_PLUGIN,
		FORM_ITEM__SINGLE_LINE
	} from "../types";
	import CreateFormApply from "../../component/CreateFormApply";
	import {
		hexToRgba
	} from "../../../assets/js/Untis";

	export default {
		mixins: [current],
		data() {
			return {
				initPer: false,
				hasFillForm: false
			}
		},
		components: {
			CreateFormApply
		},
		created() {},
		computed: {
			btnDisabled() {
				if (this.current.buttonType === BUTTON_TYPE_APPLY_FORM) {
					return this.isReadOnly
				}
				return this.isRead || this.isReadOnly
			}
		},
		methods: {
			onClickBtn() {
				if (this.btnDisabled || this.loading) {
					return
				}
				if (this.current.buttonType === BUTTON_TYPE_PLUGIN) {
					if (!this.current.pluginConfig) {
						this.$toast.fail('按钮未绑定插件')
						return
					}
					if (this.current.showAlert) {

						this.$dialog.confirm({
								title: this.current.showTitle,
								message: this.current.alertText,
								confirmButtonText: this.current.confirmText,
								cancelButtonText: this.current.cancelText,
							})
							.then(() => {
								this.submitData()
							})
							.catch(() => {});
					} else {
						this.submitData()
					}
				} else if (this.current.buttonType === BUTTON_TYPE_APPLY_FORM) {

					if (this.current.root.isLink) {
						this.$toast.fail('外链不允许发起新表单')
						return;
					}

					if (!this.current.applyAppId || !this.current.applyFormId) {
						this.$toast.fail('按钮设置错误')
						return
					}
					if (this.current.showAlert) {

						this.$dialog.confirm({
								title: this.current.showTitle,
								message: this.current.alertText,
								confirmButtonText: this.current.confirmText,
								cancelButtonText: this.current.cancelText,
							})
							.then(() => {
								this.applyForm()
							})
							.catch(() => {});
					} else {
						this.applyForm()
					}
				}
			},

			applyForm() {
				if (this.initPer) {
					if (this.hasFillForm) {
						if (this.$refs.createFormApply) {
							this.$refs.createFormApply.onClickCreate()
						}
					} else {
						this.$toast.fail('您暂无权限发起表单，请联系管理员')
					}
				} else {
					const toast = this.$toast.loading()
					this.$store.dispatch('actionFormFillPermission', {
							appId: this.current.applyAppId,
							formId: this.current.applyFormId,
						}).then(res => {
							this.initPer = true
							this.hasFillForm = res.hasPer
							if (this.hasFillForm) {
								if (this.$refs.createFormApply) {
									this.$refs.createFormApply.onClickCreate()
								}
							} else {
								this.$toast.fail('您暂无权限发起表单，请联系管理员')
							}
						}).catch(console.error)
						.finally(() => {
							toast.clear()
						})
				}
			},

			actionHexToRgba(hex, opacity) {
				return hexToRgba(hex, opacity)
			},
			createFormComplete(formSet) {
				this.$store.dispatch('actionFormButtonApplyData', {
					appId: this.current.root.appId,
					formId: this.current.root.formId,
					viewId: this.viewId,
					data: this.current.root.getValues(),
					buttonId: this.current.dataId
				}).then(res => {
					formSet.setValues(res)
				}).then(() => {
					return this.$store.dispatch('actionFormDefaultSubmitData', {
						appId: formSet.appId,
						formId: formSet.formId,
						data: formSet.getValues()
					})
				}).then(res => {
					formSet.setValues(res)
				}).catch(console.error)
			}
		}
	}
</script>

<style lang="less">
	.ry-form__item-button,
	.ry-form__item-button-compact {

		.btn {
			width: 100%;
			height: 36px;
			line-height: 34px;
			color: #fff !important;
			// max-width: 350px;
			border-radius: 4px;
			text-align: center;
			text-decoration: none;
			font-size: 14px;
			border: 1px solid transparent;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			transition: background .3s ease 0s;
			transition-duration: .3s;
		}

		.card-container {
			padding: 16px 10px;
			width: 100%;
			max-width: 600px;
			box-sizing: border-box;
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;

			.left-container {

				.btn-title {
					font-weight: 700;
					font-size: 14px;
					line-height: 150%;
					color: rgba(0, 0, 0, .85);
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.btn-des {
					font-weight: 400;
					font-size: 12px;
					line-height: 150%;
					color: #999;
					margin-top: 2px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}

			.right-container {

				.btn {
					padding: 4px 8px;
					border-radius: 2px;
					font-weight: 600;
					font-size: 12px;
					line-height: 17px;
					height: auto;
				}
			}
		}

		.dial-container {
			position: relative;
			margin: 8px;
			padding: 0 8px;
			text-align: center;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid transparent;
			cursor: pointer;
			max-width: 200px;
			float: left;

			.icon {
				width: 60px;
				height: 60px;
				border-radius: 16px;
				border: 1px solid #e6e6e6;
				box-shadow: 0 8px 10px 0 rgba(68, 137, 255, 0.14);
				overflow: visible;

				i {
					font-size: 40px;
					color: #ffffff;
				}
			}

			.menu-icon {
				display: flex;
				justify-content: center;
				align-items: center;
			}

			img {
				width: 60px;
				height: 60px;
				object-fit: cover;
			}

			.text {
				margin-top: 12px;
				line-height: 22px;
				height: 22px;
				font-size: 16px;
				color: #333333;
				width: 100%;
				text-align: center;
				text-overflow: ellipsis;
				overflow: hidden;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				white-space: normal;
				word-break: break-word;
			}
		}

		.disabled {
			background-color: #9e9e9e !important;
		}
	}

	.ry-form__item-button-compact {
		padding: 0;
	}
</style>
